(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function airyluvsTime(value) {
    if (!Number.isFinite(value)) return '0:00';
    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60).toString().padStart(2, '0');
    return minutes + ':' + seconds;
  }

  function initAiryluvsProductPreview(scope) {
    const root = scope.querySelector ? scope.querySelector('[data-airyluvs-product-recommendations]') : null;
    if (!root || root.dataset.previewReady === 'true') return;
    root.dataset.previewReady = 'true';
    const player = root.querySelector('.airyluvs-collection-player');
    const audio = root.querySelector('[data-ac-audio]');
    const seek = root.querySelector('[data-ac-seek]');
    const title = player.querySelector('[data-ac-title]');
    const status = root.querySelector('[data-ac-status]');
    const time = root.querySelector('[data-ac-time]');
    let activeButton = null;

    function setPlaying(playing) {
      player.dataset.playing = playing ? 'true' : 'false';
      if (activeButton) activeButton.setAttribute('aria-pressed', playing ? 'true' : 'false');
      status.textContent = playing ? 'Playing preview' : 'Preview paused';
    }

    function resetButtons() {
      root.querySelectorAll('[data-ac-preview]').forEach(function(button) { button.setAttribute('aria-pressed', 'false'); });
    }

    root.addEventListener('click', function(event) {
      const previewButton = event.target.closest('[data-ac-preview]');
      const toggleButton = event.target.closest('[data-ac-toggle]');
      const closeButton = event.target.closest('[data-ac-close]');
      if (previewButton) {
        event.preventDefault();
        const nextUrl = previewButton.dataset.acUrl;
        if (activeButton === previewButton && !audio.paused) { audio.pause(); return; }
        resetButtons();
        activeButton = previewButton;
        if (audio.src !== nextUrl) { audio.src = nextUrl; seek.value = 0; }
        title.textContent = previewButton.dataset.acTitle || 'Music preview';
        player.hidden = false;
        audio.play().catch(function() { status.textContent = 'Preview unavailable'; });
      } else if (toggleButton) {
        if (audio.paused) audio.play().catch(function() { status.textContent = 'Preview unavailable'; }); else audio.pause();
      } else if (closeButton) {
        audio.pause();
        audio.removeAttribute('src');
        audio.load();
        resetButtons();
        activeButton = null;
        player.hidden = true;
        seek.value = 0;
        time.textContent = '0:00 / 0:00';
      }
    });

    seek.addEventListener('input', function() {
      if (Number.isFinite(audio.duration)) audio.currentTime = (Number(seek.value) / 100) * audio.duration;
    });
    audio.addEventListener('loadedmetadata', function() { seek.disabled = false; time.textContent = '0:00 / ' + airyluvsTime(audio.duration); });
    audio.addEventListener('timeupdate', function() {
      if (Number.isFinite(audio.duration) && audio.duration > 0) seek.value = (audio.currentTime / audio.duration) * 100;
      time.textContent = airyluvsTime(audio.currentTime) + ' / ' + airyluvsTime(audio.duration);
    });
    audio.addEventListener('play', function() { setPlaying(true); });
    audio.addEventListener('pause', function() { setPlaying(false); });
    audio.addEventListener('ended', function() { setPlaying(false); seek.value = 0; });
  }

  function loadProductRecommendations() {
    const sprSection = document.querySelector('.product-recommendations');
    if (!sprSection) return;
    if (sprSection.querySelector('[data-airyluvs-product-recommendations]')) { initAiryluvsProductPreview(sprSection); return; }
    fetch(sprSection.dataset.url)
      .then(function(response) { if (!response.ok) throw response; return response.text(); })
      .then(function(html) {
        const holder = document.createElement('div');
        holder.innerHTML = html;
        const next = holder.querySelector('.product-recommendations');
        if (!next) return;
        sprSection.innerHTML = next.innerHTML;
        if (window.theme && window.theme.initAnimateOnScroll) window.theme.initAnimateOnScroll();
        initAiryluvsProductPreview(sprSection);
      })
      .catch(function(error) { console.log(error); });
  }

  document.addEventListener('shopify:section:load', loadProductRecommendations);
  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
